import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IClinicToClinicToNumber } from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setToNumber } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

export const useTONumberAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(INVENTORY_MODULE?.TO_NUMBER?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IClinicToClinicToNumber>) => {
          if (res.data.status === true) {
            dispatch(setToNumber({ data: res.data.data }));
          } else {
            dispatch(setToNumber(null));
          }
        })
        .catch((e: AxiosError) => {
          captureError(e)
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
